export const INVOICE_LIST = 'INVOICE_LIST';
export const INVOICE_DETAIL = 'INVOICE_DETAIL';
export const EXPORT_INVOICE = 'EXPORT_INVOICE';
export const PAID_INVOICE = 'PAID_INVOICE';
export const PAID_ALL_INVOICE = 'PAID_ALL_INVOICE';
